var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"my-2"},[_c('v-card-text',[_vm._v("Aaa")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }